export const LANG = "ja";  //DEPLOY
export const USE_DEFAULT_LANG = false;  //DEPLOY